import React from 'react'
import {useState} from 'hooks'
import {uuidv4} from 'utils'

export const ToastContext = React.createContext<any>({})
export const ToastInstanceContext = React.createContext<any>({})

function useToastState() {
	const [stack, setStack] = useState<any>({})

	const open = (component: any, props: any = {}) => {
		const id = uuidv4()
		setStack({
			...stack,
			[id]: {
				component,
				props,
				isOpen: true
			}
		})

		return id
	}

	const close = (id: any) => {
		setStack({
			...stack,
			[id]: {
				...stack[id],
				isOpen: false
			}
		})
	}

	const unmount = (id: any) => {
		const {[id]:_, ...nextStack} = stack
		setStack(nextStack)
	}

	return {
		stack,
		open,
		close,
		unmount
	}
}

export function ToastProvider({children}: any) {

	const state = useToastState()

	return (
		<ToastContext.Provider value={state}>
			{children}
		</ToastContext.Provider>
	)
}

export function ToastInstanceProvider({children, ...value}: any)
{
	return (
		<ToastInstanceContext.Provider value={value}>
			{children}
		</ToastInstanceContext.Provider>
	)
}
